import { render, staticRenderFns } from "./create-admins.component.html?vue&type=template&id=48f80c48&scoped=true&"
import script from "./create-admins.component.ts?vue&type=script&lang=ts&"
export * from "./create-admins.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-admins.component.scss?vue&type=style&index=0&id=48f80c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f80c48",
  null
  
)

export default component.exports